import classNames from "classnames";
import Modal from 'components/base/Modal';
import React, { useState } from 'react';
import css from "../style.scss";

const CVV99Modal = ({ showCVVModal, cardEnding, cvvLength = 3, handleSubmitCVV, handleCancel, handleClose }) => {
    const [cvv, setCvv] = useState("");
    const [error, setError] = useState({ isValid: true, error: null });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const validateCVV = (cvv) => {
        const expectedLength = cvvLength;
        if (!cvv) {
            return { isValid: false, error: 'CVV is required' };
        }
        if (!/^\d+$/.test(cvv)) {
            return { isValid: false, error: 'CVV must contain only numbers' };
        }
        if (cvv.length !== expectedLength) {
            return { isValid: false, error: `CVV must be ${expectedLength} digits` };
        }
        return { isValid: true, error: null };
    };

    const handleSubmit = () => {
        setError(validateCVV(cvv));
        if (validateCVV(cvv).isValid) {
            setIsSubmitting(true);
            handleSubmitCVV({ cardCode: cvv });
        }
    }
    return (
        <Modal modalClassName={css.pricingModal} className={classNames(css.clsAccPageModals, css.clsBillingModal, css.clsAccPrepaidCreditsModal)} isOpen={showCVVModal} uniqId="validateCVVPopup" width="auto" padding="0px 0px 0px" onClose={handleClose}>
            <div className={classNames(css.modal_lg, "modal-dialog modal-lg m-0")}>
                <div className={classNames(css.clsModalContent, "modal-content")}>
                    <div className={classNames(css.clsModalContentBody, "modal-body")}>
                        <div className={css.clsModalHeader}>
                            <h2 className={css.clsModalTitle}>Confirm Purchase</h2>
                            <h5 className={classNames(css.clsModalSubTitle, css.clsReloadSubTitle,)}>
                                Please enter the CVV to proceed with this purchase.
                            </h5>
                        </div>
                        <div className={classNames(css.clsModalBody)}>
                            <div className={classNames(css.clsModalBodyInner, "clearfix w-100")}>
                                <div className={classNames("clearfix")}>
                                    <div className={classNames(css.clsFormGroup, css.pl_16, css.pr_16, css.pt_32)}>
                                        <label className={classNames(css.clsFormLabel)}>CVV for Card ending with {cardEnding}
                                        </label>
                                        <div className={classNames(css.clsFormGroup)}>
                                            <input name="cardCode" className={css.clsFormControl} label="" placeholder="" onChange={(e) => setCvv(e.target.value)} />
                                            {!error.isValid && <p className={`${css.clsFormErrorText} ${css.text_danger}`}>
                                                {error.error}
                                            </p>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={classNames(css.clsModalFooter)}>
                            <button className={classNames(css.btn_lg, css.btn_primary, css.text_primary,)} onClick={handleCancel}> Cancel</button>
                            <button className={classNames(css.btn_lg, css.clsBtnOrng)} disabled={isSubmitting} onClick={handleSubmit}>Purchase</button>
                        </div>
                    </div>
                </div>
            </div>
        </Modal >
    )
}

export default CVV99Modal;
